// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* If using CSS modules in Remix, make sure you have properly configured your project (https://remix.run/docs/en/main/styling/css-modules#css-modules) */

._48L3Ah3dSqlsePJwdRu {
    padding: 0.25rem 0.5rem;
    border-radius: 0.5rem;
  }
  
  ._48L3Ah3dSqlsePJwdRu:hover {
    background-color: #f7f7f7;
  }
  
  .kSnz5ZTipCG6YYjVo9ZM:hover {
    background-color: inherit;
  }
  
  .Wcn4EjySqQ_PMC7dVnk4 {
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #303030;
  }
  
  .HvncDLc7sQo8jPleeGAX {
    width: 100%;
    display: flex;
    gap: 8rem;
    justify-content: space-between;
  }
  
  /* These styles take into account the Shopify sidebar visibility & hides image based on window width */
  @media (min-width: 48em) and (max-width: 61.871875em) {
    .ts4FaxDlvalxBqQeuXIX {
      display: none;
    }
  }
  
  @media (max-width: 45.625em) {
    .ts4FaxDlvalxBqQeuXIX {
      display: none;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/SetupGuide.module.css"],"names":[],"mappings":"AAAA,wJAAwJ;;AAExJ;IACI,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;IACT,8BAA8B;EAChC;;EAEA,sGAAsG;EACtG;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF","sourcesContent":["/* If using CSS modules in Remix, make sure you have properly configured your project (https://remix.run/docs/en/main/styling/css-modules#css-modules) */\r\n\r\n.setupItem {\r\n    padding: 0.25rem 0.5rem;\r\n    border-radius: 0.5rem;\r\n  }\r\n  \r\n  .setupItem:hover {\r\n    background-color: #f7f7f7;\r\n  }\r\n  \r\n  .setupItemExpanded:hover {\r\n    background-color: inherit;\r\n  }\r\n  \r\n  .completeButton {\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: #303030;\r\n  }\r\n  \r\n  .itemContent {\r\n    width: 100%;\r\n    display: flex;\r\n    gap: 8rem;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  /* These styles take into account the Shopify sidebar visibility & hides image based on window width */\r\n  @media (min-width: 48em) and (max-width: 61.871875em) {\r\n    .itemImage {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 45.625em) {\r\n    .itemImage {\r\n      display: none;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"setupItem": `_48L3Ah3dSqlsePJwdRu`,
	"setupItemExpanded": `kSnz5ZTipCG6YYjVo9ZM`,
	"completeButton": `Wcn4EjySqQ_PMC7dVnk4`,
	"itemContent": `HvncDLc7sQo8jPleeGAX`,
	"itemImage": `ts4FaxDlvalxBqQeuXIX`
};
export default ___CSS_LOADER_EXPORT___;
